import {createSlice} from '@reduxjs/toolkit';

const returnsListSlice = createSlice({
  name: 'returns',
  initialState: {
    itemsList: []
  },
  reducers: {
    setReturnsList: (state, action) => {
      state.itemsList = action.payload;
    },
    setFilteredReturnsList: (state, action) => {
      state.itemsList1 = action.payload;
    }
  },
});

export const selectReturns = (state) => state.returns;

export const {
  setReturnsList,
  setFilteredReturnsList

} = returnsListSlice.actions;

export default returnsListSlice.reducer;
